const dev = {
  baseURL: "http://localhost:8075",
};

const prod = {
  baseURL: "https://moxomx.matjarepos.com",
};

const config = process.env.NODE_ENV === "production" ? prod : dev;

export default config;